import { MessageSquareIcon } from "lucide-react";

import { Separator } from "@/components/ui/separator";

import { EmptyState } from "@/shared/components/EmptyState";

import { TicketComment } from "../types/index";
import { TicketCommentRow } from "./TicketCommentRow";

interface TicketCommentListProps {
  projectId: string;
  ticketId: string;
  comments: TicketComment[];
  /** Whether the caller has PROJECT_TICKET_COMMENTS_CREATE for this project (replies use the same permission as comments). */
  canCreateComments: boolean;
  /** Whether the caller has PROJECT_TICKET_COMMENTS_UPDATE for this project. */
  canUpdateComments: boolean;
  /** Whether the caller has PROJECT_TICKET_COMMENTS_DELETE or PROJECT_TICKET_COMMENTS_DELETE_OWN for this project. */
  canDeleteComments: boolean;
  /** Whether the caller has PROJECT_TICKET_COMMENTS_LIKE for this project. */
  canLikeComments: boolean;
}

export function TicketCommentList({ projectId, ticketId, comments, canCreateComments, canUpdateComments, canDeleteComments, canLikeComments }: TicketCommentListProps) {
  if (comments.length === 0) {
    return <EmptyState icon={MessageSquareIcon} title="No comments yet" description="Start the conversation below." />;
  }

  return (
    <div className="flex flex-col">
      {comments.map((comment, i) => (
        <div key={comment.id}>
          <TicketCommentRow projectId={projectId} ticketId={ticketId} comment={comment} canCreateComments={canCreateComments} canUpdateComments={canUpdateComments} canDeleteComments={canDeleteComments} canLikeComments={canLikeComments} />
          {i < comments.length - 1 && <Separator />}
        </div>
      ))}
    </div>
  );
}
